import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { inject } from 'vue';
import Header from './components/TheSddsHeader.vue';
import { useMainStore } from './store';
import { MenuItem } from './types/component';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const requiredRole = process.env.VUE_APP_LS_KEYCLOAK_REQUIRED_ROLE;
const frontendClient = process.env.VUE_APP_LS_KEYCLOAK_MAIN_FRONTEND_CLIENT;

const keycloak = inject('keycloak');
const store = useMainStore();

const updateToken = () => {
  keycloak.updateToken(90).then(() => {
    if (!keycloak.hasResourceRole(requiredRole, frontendClient)) {
      const logoutOptions = { redirectUri: window.location.origin };
      keycloak.logout(logoutOptions).then((success) => {
        console.log('--> log: logout success ', success);
      }).catch((error) => {
        console.log('--> log: logout error ', error);
      }).finally(() => {
        return false;
      });
    }
    console.log('updateToken');
    store.token = keycloak.token;
    return true;
  }).catch(() => {
    // handle this in some way
    return false;
  });
};

// Token lives for 5 minutes, refresh token lives for 1 hour, session lasts for 10 hours.
// Update token every 4 minutes to avoid any potential issues
// eslint-disable-next-line no-unused-vars
const updateTokenIntervalHandle = setInterval(updateToken, 240000);

const menuItems : MenuItem[] = [
  { name: 'FileView', text: 'File Importer' },
  { name: 'FileHistoryView', text: 'File History' },
];


return (_ctx: any,_cache: any) => {
  const _component_sdds_theme = _resolveComponent("sdds-theme")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_sdds_theme),
    _createVNode(Header, {
      title: "Lead Import Tool",
      "menu-items": menuItems
    }),
    _createElementVNode("div", null, [
      _createVNode(_component_router_view)
    ])
  ], 64))
}
}

})